import placeholderImg from './assets/placeholder-circle-min.png'
// Handle image load errors with fallback image
export const handleImageError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    event.currentTarget.src = placeholderImg
    event.currentTarget.alt = 'Image not available'
}
